import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import createHistory from 'history/createHashHistory';
import { ConnectedRouter } from 'react-router-redux';

import store from 'stores/';
import App from 'containers/App';
import AuthService from 'services/AuthService';

const history = createHistory();

AuthService.interceptorRequest();
AuthService.interceptResponse();

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route path="/" component={App} />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('app-container')
);



// WEBPACK FOOTER //
// ./index.js